/** Host-provided, already-localized submit error for the payment step. `null` in preview / when idle. */
export const SubmitErrorKey = Symbol("df-submit-error");
